import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Logo from './Logo';
import { SUPPORT_EMAIL } from '../utils/constants';

// Shared lightweight layout for the /privacy and /terms routes. Deliberately
// minimal: brand header that links home, the legal copy, and a small footer —
// the landing page's anchor nav wouldn't resolve from these routes.
// (Scroll-to-top on navigation is handled route-wide by ScrollToTop in App.js.)
const LegalPage = ({ title, updated, children }) => {
  const year = new Date().getFullYear();

  return (
    <div className="legal-page">
      <Helmet>
        <title>{`${title} — SolidlyAI Agents`}</title>
      </Helmet>

      <header className="legal-header">
        <Link to="/" className="nav-brand" aria-label="SolidlyAI Agents home">
          <span className="nav-logo" aria-hidden="true">
            <Logo size={26} />
          </span>
          <span className="nav-brand-text">
            SolidlyAI <span className="nav-brand-accent">Agents</span>
          </span>
        </Link>
        <Link to="/" className="legal-back">
          ← Back to site
        </Link>
      </header>

      <main className="section-container legal-content">
        <h1>{title}</h1>
        <p className="legal-updated mono">Last updated: {updated}</p>
        {children}
      </main>

      <footer className="footer-bottom legal-footer">
        <span className="mono">© {year} SolidlyAI Agents</span>
        <span className="mono">
          Questions? <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
        </span>
      </footer>
    </div>
  );
};

export default LegalPage;
